import { IApplication } from 'core/interfaces/Application'
import { IResponsable } from 'core/interfaces/Responsable'
import { SelectedUtilisateur } from 'lauria/types/selectedUtilisateur'
import { getUtilisateurDisplayLabel } from 'lauria/utils/utilisateurLabel'

export function mapResponsableToSelectedUtilisateur(
  responsable: IResponsable
): SelectedUtilisateur {
  return {
    id: responsable.id,
    label: getUtilisateurDisplayLabel(responsable),
  }
}

export function getApplicationMcpUtilisateurIds(
  application: Pick<IApplication, 'mcpUtilisateurs' | 'mcpUtilisateurIds'>
): number[] {
  if (application.mcpUtilisateurs?.length) {
    return application.mcpUtilisateurs.map((utilisateur) => utilisateur.id)
  }

  return application.mcpUtilisateurIds ?? []
}

export function getAdditionalMcpUtilisateursFromApplication(
  application: Pick<IApplication, 'mcpUtilisateurs' | 'mcpUtilisateurIds'>,
  responsableIds: number[]
): SelectedUtilisateur[] {
  const responsableIdSet = new Set(responsableIds)

  if (application.mcpUtilisateurs?.length) {
    return application.mcpUtilisateurs
      .filter((utilisateur) => !responsableIdSet.has(utilisateur.id))
      .map(mapResponsableToSelectedUtilisateur)
  }

  const additionalIds = (application.mcpUtilisateurIds ?? []).filter(
    (id) => !responsableIdSet.has(id)
  )

  return additionalIds.map((id) => ({
    id,
    label: String(id),
  }))
}
